export default "__VITE_ASSET__CNx9iKYr__"